export class CompanyUpdateFeatureModel {
    companySurrkey: number;
    isQoPhoto: number;
    isActiveLocationFeature: number;
    isDatawarehouse: number;
    isAccess: number;
    isBadge: number;
    isHide: number;
    isActiveLocationOffLimit: number;
    isGeoMap: number;
    isAccessWebhook: number;
}
